import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

// components
import { PriceAmount } from './PriceAmount';

// helpers
import { getAmountByCurrency } from './helpers';
import get from 'lodash.get';

/**
 * Price Components for an item with a net price
 *  (Net or Net & Retail)
 */
export function NetItemPrices({ showRetail, currency, pricing, quantityDisplay }) {
    const { netPrice, retailPrice } = pricing;
    const netAmount = getAmountByCurrency(netPrice, currency);
    const retailAmount = showRetail && getAmountByCurrency(retailPrice, currency);

    let discount;
    if (retailAmount && netAmount) {
        discount = get(pricing, 'percentageOff.netPrice');
    }

    return (
        <Fragment>
            {/* NET PRICE */}
            {!!netAmount && (
                <PriceAmount
                    type="NET"
                    showLabel
                    amount={netAmount}
                    currency={currency}
                    quantityDisplay={quantityDisplay}
                />
            )}
            {/* RETAIL PRICE */}
            {!!retailAmount && (
                <PriceAmount
                    hasNetPrice
                    discount={discount}
                    currency={currency}
                    amount={retailAmount}
                    quantityDisplay={quantityDisplay}
                />
            )}
        </Fragment>
    );
}

NetItemPrices.propTypes = {
    showRetail: PropTypes.bool.isRequired,
    currency: PropTypes.string,
    quantityDisplay: PropTypes.string,
    pricing: PropTypes.shape({
        retailPrice: PropTypes.object,
        netPrice: PropTypes.object.isRequired,
    }).isRequired,
};
